module.exports = __webpack_public_path__ + "globe.png?72a357a1387f0c8fb643683b93d295db";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/globe.png
// module id = 33
// module chunks = 0